import { PayTypeModalProps } from "./types"
import React from "react"
import { Mask } from "~widgets/mask"
import styled from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"
import { Modal, Image } from "~/ui/primitives"
import Icon from "~widgets/icon"
import { observer } from "mobx-react-lite"
import { useStores } from "~models"

const wechatImg = require("../../assets/images/wallet/wechat.png")
const alipayImg = require("../../assets/images/wallet/alipay.png")
const bankImg = require("../../assets/images/wallet/bank.png")
const ModalWrap = styled.View`
  flex: 1;
`
const ModalBg = styled.View`
  position: absolute;
  bottom: 0px;
  width: 100%;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
`
const ContentArea = styled.View`
  z-index: 2;
  position: absolute;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-color: rgb(200, 200, 200);
  border-width: 1px;
  border-radius: 25px;
  padding-bottom: 50px;
`
const ContentBlock = styled.TouchableOpacity`
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
`
const ModalTitle = styled.Text`
  color: black;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  font-weight: bold;
  padding: 20px;
`
const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: rgb(0, 0, 0);
  flex: 4;
  padding: ${({ theme }) => theme.space.md};
`

const PayTypeModal: React.FC<PayTypeModalProps> = ({
  visible,
  setVisible,
  title,
  callBack,
  paymentMethods,
}) => {
  const { walletStore } = useStores()
  const getImage = (tye) => {
    switch (tye) {
      case 0:
        return bankImg
      case 1:
        return alipayImg
      case 2:
        return wechatImg
      default:
        break
    }
  }
  const getPayName = (tye) => {
    switch (tye) {
      case 0:
        return "银行卡"
      case 1:
        return "支付宝"
      case 2:
        return "微信"
      default:
        break
    }
    return null
  }
  return (
    <Modal visible={visible} animationType={"fade"} transparent={true}>
      <ModalWrap>
        <Mask onClick={() => setVisible(false)} />
        <ModalBg>
          <ContentArea>
            <ContentBlock
              onClick={() => {
                setVisible(false)
              }}
              style={{ position: "absolute", right: 10, top: 10 }}
            >
              <Text style={{ color: "rgb(200,200,200)" }}>关闭</Text>
            </ContentBlock>
            <ContentBlock
              style={{
                alignItems: "center",
              }}
            >
              <ModalTitle>{title}</ModalTitle>
            </ContentBlock>
            {walletStore.paymentList?.map((payment, i) => {
              if (!paymentMethods.includes(payment.pay_type)) return null
              return (
                <ContentBlock
                  key={`${payment.pay_type}-${payment.pay_account}-${i}`}
                  onClick={() => {
                    // setPayType(EPayType.BANK);
                    setVisible(false)
                    callBack(payment)
                  }}
                  style={{
                    flexDirection: "row",
                    borderTopColor: "rgb(200,200,200)",
                    borderTopWidth: 0.5,
                    justifyContent: "flex-end",
                  }}
                >
                  <Image src={getImage(payment.pay_type)} style={{ width: 20, height: 20 }} />
                  <Text>
                    {getPayName(payment.pay_type)} {payment.pay_account}
                  </Text>
                  <Icon name={"rightArrow"} size={20} color={"rgb(170,170,170)"} />
                </ContentBlock>
              )
            })}
            {/* <ContentBlock
              onClick={() => {
                // setPayType(EPayType.BANK);
                setVisible(false);
              }}
              style={{
                flexDirection: 'row',
                display: 'flex',
                borderTopColor: 'rgb(200,200,200)', borderTopWidth: 0.5, width: '100%'
              }}
            >
              <Image
                src={bankImg}
                style={{ width: 20, height: 20 }}
              />
              <Text>{"银行卡"}</Text>
              <Icon name={"rightArrow"} size={20} color={'rgb(170,170,170)'} />

            </ContentBlock>

            <ContentBlock
              onClick={() => {
                // setPayType(EPayType.ALIPAY)
              }}
              style={{
                flexDirection: 'row',
                display: 'flex',
              }}
            >
              <Image
                src={alipayImg}
                style={{ width: 20, height: 20 }}
              />
              <Text>{"支付宝"}</Text>
              <Icon name={"rightArrow"} size={20} color={'rgb(170,170,170)'} />

            </ContentBlock>

            <ContentBlock
              onClick={() => {
                // setPayType(EPayType.WECHAT)
              }}
              style={{
                flexDirection: 'row',
                display: 'flex', paddingBottom: 70
              }}
            >
              <Image
                src={wechatImg}
                style={{ width: 20, height: 20 }}
              />
              <Text>{"微信"}</Text>
              <Icon name={"rightArrow"} size={20} color={'rgb(170,170,170)'} />

            </ContentBlock>
  */}
          </ContentArea>
        </ModalBg>
      </ModalWrap>
    </Modal>
  )
}

export default observer(PayTypeModal)
